import "chartjs-adapter-date-fns";
import styled from "@emotion/styled";
import { ThemeProps } from "types/theme";
import { withTheme } from "@emotion/react";
import {
  CategoryScale,
  Chart as ChartJS,
  ChartOptions,
  LineElement,
  LinearScale,
  PointElement,
  TimeScale,
  TimeSeriesScale,
} from "chart.js";
import { Line } from "react-chartjs-2";
import i18n from "i18n";
import { format, parse, parseISO } from "date-fns";
import { enGB, it } from "date-fns/locale";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  TimeSeriesScale
);

const ChartWrapper = styled.div`
  height: 200px;
  width: 100%;
  position: relative;
`;

type Props = {
  title?: string;
  growthValues: {
    date: string;
    value: number;
  }[];
};

const GrowthChart = ({ theme, growthValues }: ThemeProps & Props) => {
  const linguaCorrente = i18n.language;
  const { t } = useTranslation();

  const data = {
    labels: growthValues?.map((dp) => dp.date),
    datasets: [
      {
        label: "Followers",
        data: growthValues?.map((dp) => dp.value),
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.primary.main,
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  const options: ChartOptions<"line"> = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
    },
    scales: {
      x: {
        type: "time",
        time: {
          unit: "month",
          displayFormats: {
            month: "MMM yyyy",
          },
          tooltipFormat: "PP",
        },
        grid: {
          display: false,
        },
        ticks: {
          source: "labels",
          callback: function (tickValue: string | number) {
            const date = new Date(tickValue);
            if (date.getDate() === 1) {
              return format(date, "MMM yyyy", {
                locale: linguaCorrente === "it" ? it : enGB,
              });
            }
            return "";
          },
        },
      },
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Followers",
        },
      },
    },
  };

  return (
    <>
      {!growthValues || growthValues?.length === 0 && (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Typography>{t("empty_states.empty_stats.title")}</Typography>
        </div>
      )}
      <ChartWrapper>
        <Line options={options} data={data} />
      </ChartWrapper>
    </>
  );
};

export default withTheme(GrowthChart);
